import api from './api';
import { Dayjs } from 'dayjs';

export interface TimekeepingRecord {
  ngayCham?: string;
  gioCham?: string;
  tenMay?: string;
}

export const timekeepingService = {
  async getTimekeepingRecords(fromDate: Dayjs, toDate: Dayjs): Promise<TimekeepingRecord[]> {
    try {
      // Format dates to YYYY-MM-DD for the API
      const params = new URLSearchParams();
      params.append('fromDate', fromDate.format('YYYY-MM-DD'));
      params.append('toDate', toDate.format('YYYY-MM-DD'));
      
      const response = await api.get('/timekeeping', { params });
      
      // Ensure the response data is an array
      if (!Array.isArray(response.data)) {
        console.warn('Expected array but got:', response.data);
        return [];
      }
      
      return response.data;
    } catch (error) {
      console.error('Error in getTimekeepingRecords:', error);
      throw error;
    }
  },

  getMySummary(thang: number, nam: number) {
    return api.get('/timekeeping/my-summary', {
      params: { thang, nam }
    });
  },

  getDanhMucLoai() {
    return api.get('/timekeeping/danh-muc-loai');
  },

  getDanhMucLoaiPhu() {
    return api.get('/timekeeping/danh-muc-loai-phu');
  },

  getCauHinhCa(maKhoa?: number) {
    return api.get('/timekeeping/cau-hinh-ca', {
      params: { maKhoa }
    });
  }
};
